import * as Types from "./mutation-types";

const mutations = {
  [Types.SETDICTIONARY](state, result) {
    state.dictionaryList = result;
  },
  [Types.SETMEMBERTYPE](state, result) {
    state.memberTypeList = result;
  },
  [Types.SETBRANCHS](state, result) {
    state.branchsList = result;
  },
  [Types.SETZHICHENG](state, result) {
    state.zhichengList = result;
  },
  [Types.SETCITY](state, result) {
    state.cityList = result;
  },
  [Types.SETTOKEN](state, result) {
    state.access_token = result;
  },
  [Types.SETREFRESHTOKEN](state, result) {
    state.access_token = result;
  },
  setMemberInfo(state, result) {
    state.userInfo = result;
  },
  setTitleList(state, result) {
    state.titleList = result;
  },
  setAddrList(state, result) {
    state.addrList = result;
  },
  setDictionary(state, data) {
    state.dictionary = data;
  },
};

export default mutations;